import { compose, lifecycle, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { selectors as settingsSelectors } from 'state/settings';
import { actions as orderActions } from 'state/order';
import {
  actions as paymentDataActions,
  selectors as paymentDataSelectors,
} from 'state/paymentData';

import BillingInfoForm from 'components/PaymentData/BillingInfoForm/component';

const enhance = compose(
  withTranslation('PaymentData'),
  connect(
    (state) => ({
      country: settingsSelectors.getCountrySettings(state),
      fiscalInfo: paymentDataSelectors.getFiscalInfo(state),
    }),
    {
      fetchQuote: orderActions.fetchQuote,
      changeFiscalInfo: paymentDataActions.changeFiscalInfo,
      changeBillingContact: paymentDataActions.changeBillingContact,
    }
  ),
  lifecycle({
    componentDidMount() {
      const { fetchQuote } = this.props;

      fetchQuote();
    },
  }),

  withHandlers({
    handleChangeFiscalInfo:
      ({ changeFiscalInfo }) =>
      (e, { name, value }) => {
        e.preventDefault();

        changeFiscalInfo({ field: name, value });
      },
    handleChangeBillingContact:
      ({ changeBillingContact }) =>
      (e, { name, value }) => {
        e.preventDefault();

        changeBillingContact({ field: name, value });
      },
  })
);

export default enhance(BillingInfoForm);
